import { createRouter, createWebHistory } from '@ionic/vue-router';

const routes = [
  {
    path: '/',
    component: () => import("@/views/HomePage.vue")
  },
  {
    path: '/login',
    component: () => import("@/views/Login.vue")
  },
  {
    path: '/slides',
    component: () => import("@/views/Slides.vue")
  },
  {
    path: '/registro',
    component: () => import("@/views/Registro.vue")
  },
  {
    path: '/recuperar',
    component: () => import("@/views/Recuperar.vue")
  },
  // Rutas de resultado de pago RedSys
  {
    path: '/pago-ok',
    name: 'pago-ok',
    component: () => import("@/views/PagoOk.vue")
  },
  {
    path: '/pago-ko',
    name: 'pago-ko',
    component: () => import("@/views/PagoKo.vue")
  },
  {
    path: '/tabs/',
    component: () =>
      import("@/views/Index.vue"),
    children: [
      {
        path: '',
        component: () => import("@/views/tabs/Index.vue"),
        children: [
          {
            path: 'tab1',
            component: () => import("@/views/tabs/home/Home.vue"),
          },
          {
            path: 'tab2',
            component: () => import('@/views/tabs/tab2/Tab2.vue')
          },
          {
            path: 'tab3',
            component: () => import('@/views/tabs/tab3/Tab3.vue')
          },
          {
			path: '/especialidades',
			name: 'especialidades',
			component: () => import("@/views/Especialidades.vue")
           },
          {
			path: '/historico',
			name: 'historico',
			component: () => import("@/views/Historico.vue")
           },
          {
			path: '/ajustes',
			name: 'ajustes',
			component: () => import("@/views/Ajustes.vue")
           },
          {
			path: '/facturacion',
			name: 'facturacion',
			component: () => import("@/views/Facturacion.vue")
           },
          {
			path: '/respuestas',
			name: 'respuestas',
			component: () => import("@/views/Respuestas.vue")
           },
          {
			path: '/caso/:caso',
			name: 'caso',
			component: () => import("@/views/Caso.vue")
           },
          {
			path: '/responder/:caso',
			name: 'responder',
			component: () => import("@/views/Responder.vue")
           },
          {
			path: '/expediente/:caso',
			name: 'expediente',
			component: () => import("@/views/Expediente.vue")
           },
          {
			path: '/cliente/:caso',
			name: 'cliente',
			component: () => import("@/views/Cliente.vue")
           },
        ]
      },

    ]
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
